// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BadgeInfo_wrapper__SZ4jC","image":"BadgeInfo_image__lgFMq"};